import React, {useState} from "react";
import {
    IonIcon, useIonAlert
} from "@ionic/react";
import {
    documentTextOutline,
    mailOutline,
    businessOutline,
    personOutline,
    locationOutline,
    phonePortraitOutline
} from "ionicons/icons";
import {callFunctionToDownload} from "../lib/downloadHelper";
import {
    actionToGetDeservingCandidateEmailTemplate
} from "../apiHelpers/CommonAction";
import useStore from "../zustand/useStore";

const JobUserProfileDetailComponent = ({deservingCandidatesProfileData}) => {
    const {userJobPostData} = useStore();
    const [presentAlert] = useIonAlert();
    const [jobData,setJobData] = useState(userJobPostData?.jobPostData?.[0]);


    // Let openMailClient optionally take a specific job
    const openMailClient = async (jobArg = jobData) => {
        const job = jobArg || userJobPostData?.jobPostData?.[0];
        if (!job) return;

        const template = await actionToGetDeservingCandidateEmailTemplate();
        const subject = encodeURIComponent(`Shortlisted for ${job.title} at ${job.company}`);

        let body = "Hello,\n\nI am interested in applying for this job position.\n\nThanks.";

        if (template) {
            const filledTemplate = template
                .replace(/{JOB_ID}/g, job?.id || "-")
                .replace(/{CANDIDATE_NAME}/g, deservingCandidatesProfileData?.name || "-")
                .replace(/{COMPANY_NAME}/g, job?.company || "-")
                .replace(/{JOB_TITLE}/g, job?.title || "")
                .replace(/{HR_EMAIL}/g, job?.apply_email || "")
                .replace(/{COMPANY_EMAIL}/g, job?.apply_email || "")
                .replace(/{COMPANY_MOBILE}/g, job?.company || "");

            body = encodeURIComponent(filledTemplate);
        }

        window.location.href = `mailto:${deservingCandidatesProfileData?.email}?subject=${subject}&body=${body}`;
    };

    const selectJobForCandidate = async () => {
        const jobs = userJobPostData?.jobPostData || [];

        if (!jobs.length) {
            presentAlert({
                header: 'Alert!',
                cssClass: 'custom_site_alert_toast',
                message: 'You dont have any job posts added yet.',
                buttons: [{ text: 'Okay', role: 'confirm', handler: () => openMailClient() }],
            });
            return;
        }

        // Build radio inputs from job titles
        const inputs = jobs.map((j) => ({
            type: 'radio',
            label: j.title || `Job #${j.id}`,
            value: j.id,
            checked: j.id === jobData?.id,
        }));

        presentAlert({
            header: 'Select a Job',
            message: 'Choose the job for which you want to email the candidate.',
            inputs,
            buttons: [
                { text: 'Cancel', role: 'cancel' },
                {
                    text: 'Select',
                    handler: (selectedId) => {
                        const selectedJob = jobs.find((j) => j.id === selectedId);
                        if (selectedJob) {
                            setJobData(selectedJob);
                            // Use the selected job immediately (avoids async state timing)
                            openMailClient(selectedJob);
                        }
                    },
                },
            ],
        });
    };


    return (
        <>
            {(deservingCandidatesProfileData?.id) ?
                <div key={deservingCandidatesProfileData?.id} className="applied_member_container">
                    {/* Header */}
                    <div className="member_header">
                        <IonIcon icon={personOutline} className="icon" />
                        <div className="info">
                            <h2><strong>{deservingCandidatesProfileData.name}</strong></h2>
                            <p>Category: {deservingCandidatesProfileData.category}</p>
                        </div>
                    </div>

                    {/* Details */}
                    <div className="member_details">
                        <div className="detail_item">
                            <IonIcon icon={mailOutline} className="icon" />
                            <p>{deservingCandidatesProfileData.email}</p>
                        </div>

                        <div className="detail_item">
                            <IonIcon icon={locationOutline} className="icon" />
                            <p>Location: {deservingCandidatesProfileData.location}</p>
                        </div>

                        <div className="detail_item">
                            <IonIcon icon={businessOutline} className="icon" />
                            <p>Work Type: {deservingCandidatesProfileData.work_type}</p>
                        </div>

                        <div className="detail_item">
                            <IonIcon icon={mailOutline} className="icon" />
                            <p>Email: {deservingCandidatesProfileData.email}</p>
                        </div>

                        <div className="detail_item">
                            <IonIcon icon={phonePortraitOutline} className="icon" />
                            <p>Phone: {deservingCandidatesProfileData.phone}</p>
                        </div>
                    </div>

                    {/* Salary info */}
                    <div className="member_salary">
                        <div className="salary_box">
                            <p><strong>Current Salary:</strong> {deservingCandidatesProfileData.current_salary}</p>
                        </div>
                        <div className="salary_box">
                            <p><strong>Expected Salary:</strong> {deservingCandidatesProfileData.expected_salary}</p>
                        </div>
                    </div>

                    {/* View CV Button */}
                    <div className="view_cv_container">
                        <button
                            className="view_cv_btn"
                            onClick={() => callFunctionToDownload(deservingCandidatesProfileData.cv_url)}
                        >
                            <IonIcon icon={documentTextOutline} className="icon" />
                            Download CV
                        </button>
                        <button
                            className="view_cv_btn"
                            onClick={()=>selectJobForCandidate()}
                        >
                            <IonIcon icon={documentTextOutline} className="icon" />
                            Send Mail
                        </button>
                    </div>
                </div>
                :
                <div className="applied_member_container">
                    {/* Header */}
                    <div className="member_header">
                        <div className="info">
                            <p>No matching profile found</p>
                        </div>
                    </div>
                </div>
            }
        </>
    );
};

export default JobUserProfileDetailComponent;
